import { DeliveryType } from '@libs/core';

export interface DeliveryTypeFlags {
    isBopis: boolean;
    isSTH: boolean;
    isSDD: boolean;
    isAutoship: boolean;
    isSTM: boolean;
}

export function getDeliveryType(fulfillmentMethod?: string | null): DeliveryTypeFlags {
    const normalized = fulfillmentMethod?.toLowerCase();
    return {
        isBopis: normalized === DeliveryType.BOPIS,
        isSTH: normalized === DeliveryType.STH,
        isSDD: normalized === DeliveryType.SDD,
        isAutoship: normalized === DeliveryType.AUTOSHIP,
        isSTM: normalized === DeliveryType.STM,
    };
}
